import { useOutletContext } from 'react-router-dom';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Switch from 'components/shared/Switch/Switch';

const PatientCommunicationSettings = () => {
  const { practice, handleChange, updateDisabled } = useOutletContext();
  return (
    <div className="overflow-auto !pr-1">
      <p className="pb-1 text-lg font-600 text-neutral-700">Patient Communication</p>
      <div className="grid grid-cols-4 gap-4 sm:grid-cols-2 md:grid-cols-3 xs:grid-cols-1">
        <div className="flex flex-col gap-2 rounded-md border border-solid border-neutral-200 !p-3">
          <div>Emails Enabled</div>
          <div>
            <Switch
              onChange={(e) => handleChange({ name: 'emails_enabled', state: e })}
              checked={practice?.emails_enabled}
              disabled={updateDisabled}
            />
          </div>
        </div>
        <div className="flex flex-col gap-2 rounded-md border border-solid border-neutral-200 !p-3">
          <div>Texts Enabled</div>
          <div>
            <Switch
              onChange={(e) => handleChange({ name: 'texts_enabled', state: e })}
              checked={practice?.texts_enabled}
              disabled={updateDisabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(PatientCommunicationSettings);
